import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { CircleX } from 'lucide-react';
import type React from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import BaseLayout from '@/layouts/base';

const ErrorPage = ({ children }: React.PropsWithChildren) => {
  const { t } = useTranslation();

  return (
    <BaseLayout className="-md:justify-center space-y-8" size="sm">
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <CircleX />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('errorPage.default.title')}</PageHeadingTitle>
        <PageHeadingDescription>{children ?? t('errorPage.default.description')}</PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <a href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}>{t('contactSupport')}</a>
      </Button>
    </BaseLayout>
  );
};
ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
